function loadingInfo() {
    return <div style={{ color: '#666' }}>Loading…</div>;
}

function renderRealEstateInfo(place, listings) {
    const item = listings.find((listing) => listing.id === place?.id);
    if (!item) return loadingInfo();

    const addressLine = [item.city, item.state, item.postalCode].filter(Boolean).join(', ');
    const price = item.price != null ? `$${Number(item.price).toLocaleString()}` : '';
    const description = [item.propertyType, item.sourceName].filter(Boolean).join(' • ');

    return (
        <div>
            <div style={{ fontWeight: 700, marginBottom: 4 }}>{item.address || '(no address)'}</div>
            <div style={{ color: '#666', marginBottom: 6 }}>{addressLine || '—'}</div>
            <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
                {price && <span style={{ fontWeight: 700 }}>{price}</span>}
                {description && <span style={{ color: '#555', fontSize: 12 }}>{description}</span>}
            </div>
        </div>
    );
}

function renderPlaceInfo(place, places) {
    const item = places.find((result) => result.id === place?.id);
    if (!item) return loadingInfo();

    const categories = item.categoryNames || item.types || [];
    const rating = item.rating != null ? Number(item.rating).toFixed(1) : '';
    const distance = item.distance != null ? `${item.distance} m` : '';

    return (
        <div>
            <div style={{ fontWeight: 700, marginBottom: 4 }}>{item.name || '(unnamed)'}</div>
            <div style={{ color: '#666', marginBottom: 4, fontSize: 12 }}>{item.formattedAddress || '—'}</div>
            <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
                {rating && <span style={{ fontWeight: 700, color: '#e8770e' }}>★ {rating}</span>}
                {categories.slice(0, 2).map((category, index) => (
                    <span key={index} style={{ color: '#555', fontSize: 12 }}>
                        {category}
                    </span>
                ))}
                {distance && <span style={{ color: '#999', fontSize: 12 }}>{distance}</span>}
            </div>
        </div>
    );
}

export function createMapInfoRenderer({ showRealEstate, showPlaces, combinedReListings, placesResults }) {
    if (showRealEstate) return (place) => renderRealEstateInfo(place, combinedReListings);
    if (showPlaces) return (place) => renderPlaceInfo(place, placesResults);
    return undefined;
}
